"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const store_1 = require("../../store");
const icon_1 = require("../../components/icon/icon");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const screenConstants_1 = require("../../constants/screenConstants");
const appMessageLayout_1 = __importDefault(require("../../components/appMessage/appMessageLayout"));
const EmailConfirmed = () => {
    const navigation = (0, useAppNavigation_1.default)();
    const token = (0, store_1.useAppSelector)((state) => state.auth.token);
    return (react_1.default.createElement(appMessageLayout_1.default, { icon: icon_1.APPMESSAGE_CHECK_CIRCLE, textTitle: "Successful", textSubtitle: "Your email is validated. You can now continue your account creation.", buttonTextPrimary: "Continue", onPressPrimary: token ? () => navigation.navigate(screenConstants_1.HOME_SCREEN) : () => navigation.navigate(screenConstants_1.SIGN_IN_SCREEN), eventNamePrimary: "email_confirmed_continue" }));
};
exports.default = EmailConfirmed;
